import React, { useEffect, useState } from 'react'
import { Button, Header } from '../../components'
import { BsFillBuildingFill, BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import { Link, useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import Loading from '../../components/Loading';
import { useStateContext } from '../../contexts/ContextProvider';
import { AiTwotoneEdit } from 'react-icons/ai';
import ActionButton from '../../components/ActionButton';
import AddClasse from './AddClasse';
import EditClasse from './EditClasse';
import { MdPrint } from 'react-icons/md';
import PrintList from './PrintList';
import TabHead from '../../components/TabHead';
import HourLoading from '../../components/HourLoading';

const Classes = () => {
  const navigate = useNavigate();
  const [classes, setClasses] = useState(null);
  const [loading, setLoading] = useState(true);
  const { setToken, user } = useStateContext();
  const [showAdd, setShowAdd] = useState(false);

  const [showEdit, setShowEdit] = useState(false);
  const [showPrintList, setShowPrintList] = useState()
  const [selcetedClasse, setSelectedClasse] = useState(null);
  const getClasses = () => {
    axiosClient.get('/classes')
      .then((data) => {
        setClasses(data.data.classes);
        setLoading(false);

      }).catch(err => {
        const response = err.response;
        if (err.response.status === 401) {
          setToken(null);
        } else {
          if (response.status === 401) {
            setToken(null);
          }
          else {
            if (response.status === 403) {
              navigate('/403');
            } else {
              if (response.status === 404) {
                navigate('/404');
              }
              else {
                navigate('/500');
              }
            }
          }
        }

      })
  }

  const closeAdd = () => {
    setShowAdd(false);
    getClasses();
  }

  const closeEdit = () => {
    setShowEdit(false);
    setSelectedClasse(null);
    getClasses();
  }

  const closeShowPrintList = () => {
    setShowPrintList(false);
    setSelectedClasse(null);
  }

  useEffect(() => {
    getClasses();
  }, []);
  return (
    <>
      <Header icon={<BsFillBuildingFill />} category='Page' title='Classes' titleAr="الأقسام"/>
      <div className='flex-col '>
        <div className='items-end'>
          {user.role && user.role.name === 'admin' ?
            <Button color="bg-blue-500" onClick={() => {
              setShowAdd(true);
            }} icon={<BsPlusCircleFill />} size="20" text="Ajouter" textColor="text-white" />
            :
            <></>
          }
        </div>
        <div className='mt-3 w-full overflow-x-auto'>
          {loading ? <HourLoading /> :
            (
              <table className='table-auto'>
                <thead>
                  <tr>
                    <th><TabHead left="Groupe" right="G"/></th>
                    <th><TabHead left="Code" right="الرمز"/></th>
                    <th><TabHead left="Libelle" right="الإسم"/></th>
                    <th><TabHead left="Prix" right="السعر"/></th>
                    <th><TabHead left="Capacite" right="الإستيعاب"/></th>
                    <th><TabHead left="Actions" right={"إجراء"}/></th>
                  </tr>
                </thead>
                <tbody>
                  {classes && classes.map(o => (
                    <tr key={o.id}>
                      <td>{o.groupe}</td>
                      <td>{o.code}</td>
                      <td>{o.libelle}</td>
                      <td>{o.prix}</td>
                      <td>{o.capacite}</td>
                      <td>
                        <div className="flex justify-evenly">
                          {user.role && user.role.name === 'admin' ?
                            <>
                              <ActionButton onClick={() => {
                                setSelectedClasse(o);
                                setShowEdit(true);
                              }} color="bg-green-500" icon={<AiTwotoneEdit />} textColor="text-white" title="Modifier" />
                              <ActionButton color="bg-red-500" icon={<BsTrash />} textColor="text-white" title="Supprimer" />
                            </>
                            :
                            <>
                            </>
                          }
                          <ActionButton onClick={() => {
                            setSelectedClasse(o);
                            setShowPrintList(true);
                          }} color="bg-green-500" icon={<MdPrint />} textColor="text-white" title="Modifier" />

                        </div>
                      </td>
                    </tr>
                  ))

                  }
                </tbody>
              </table>
            )

          }
        </div>
      </div>
      {
        showAdd ? <AddClasse onClose={closeAdd} /> : <></>
      }
      {
        showEdit ? <EditClasse selectedClasse={selcetedClasse} onClose={closeEdit} /> : <></>
      }
      {
        showPrintList ? <PrintList selectedClasse={selcetedClasse} onClose={closeShowPrintList} /> : <></>
      }
    </>
  )
}

export default Classes